// Happy cleaning songs made with Web Audio (no files needed).
const SEMI = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
const hz = (n) => {
  const m = /^([A-G])(#?)(\d)$/.exec(n);
  return 440 * 2 ** ((SEMI[m[1]] + (m[2] ? 1 : 0) + (Number(m[3]) + 1) * 12 - 69) / 12);
};

// melody/bass: one entry per step, '-' = rest. drums: k=kick, s=snare, h=hihat per step.
export const SONGS = {
  disco: {
    label: 'Disco', emoji: '🪩', step: 0.13, lead: 'square', leadVol: 0.25,
    melody: 'E5 - G5 - A5 G5 E5 - D5 - E5 - G5 - E5 D5 C5 - A4 - C5 - D5 - E5 - D5 C5 A4 - G4 - A4 - C5 - D5 - C5 -',
    bass: 'C3 C4 C3 C4 C3 C4 C3 C4 A2 A3 A2 A3 A2 A3 A2 A3 F2 F3 F2 F3 F2 F3 F2 F3 G2 G3 G2 G3 G2 G3 G2 G3',
    drums: 'kh h sh h kh h sh h',
  },
  piano: {
    label: 'Lugnt piano', emoji: '🎹', step: 0.32, lead: 'sine', leadVol: 0.55,
    melody: 'E5 D5 C5 D5 E5 E5 E5 - D5 D5 D5 - E5 G5 G5 - E5 D5 C5 D5 E5 E5 E5 C5 D5 D5 E5 D5 C5 - - -',
    bass: 'C3 G3 E4 G3 C3 G3 E4 G3 G2 D3 B3 D3 C3 G3 E4 G3 C3 G3 E4 G3 A2 E3 C4 E3 G2 D3 B3 D3 C3 G3 C4 -',
    drums: '',
  },
  march: {
    label: 'Marschorkester', emoji: '🥁', step: 0.22, lead: 'sawtooth', leadVol: 0.18,
    melody: 'G4 G4 C5 - C5 D5 E5 C5 E5 - D5 C5 D5 - G4 - G4 G4 C5 - C5 D5 E5 C5 G5 - F5 E5 D5 - C5 -',
    bass: 'C3 - G2 - C3 - G2 - C3 - G2 - G2 - D3 - C3 - G2 - C3 - G2 - G2 - G2 - C3 - - -',
    drums: 'k s k s k s ks s',
  },
  waltz: {
    label: 'Vaggande vals', emoji: '💃', step: 0.24, lead: 'triangle', leadVol: 0.5,
    melody: 'C5 - E5 G5 - - G5 - A5 G5 - - F5 - E5 D5 - - D5 - F5 A5 - - A5 - B5 A5 - - G5 - - - - -',
    bass: 'C3 E4 E4 C3 G3 G3 F3 A3 A3 C3 E4 E4 G2 F3 F3 G2 B3 B3 G2 D4 D4 C3 E4 E4',
    drums: 'k h h',
  },
  game: {
    label: 'Glatt spel-tema', emoji: '🕹️', step: 0.11, lead: 'square', leadVol: 0.22,
    melody: 'E5 E5 - E5 - C5 E5 - G5 - - - G4 - - - C5 - - G4 - - E4 - - A4 - B4 - A#4 A4 - G4 E5 G5 A5 - F5 G5 - E5 - C5 D5 B4 - - -',
    bass: 'C3 - C3 - G2 - G2 - C3 - C3 - G2 - G2 - A2 - A2 - E2 - E2 - F2 - F2 - G2 - G2 -',
    drums: 'k h s h',
  },
};

const parse = (s) => s.trim().split(/\s+/).filter(Boolean);

export function createMelody(songId = 'disco') {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const master = ctx.createGain();
  master.gain.value = 0.18;
  master.connect(ctx.destination);
  const noise = ctx.createBuffer(1, ctx.sampleRate * 0.2, ctx.sampleRate);
  noise.getChannelData(0).forEach((_, i, a) => { a[i] = Math.random() * 2 - 1; });
  let song = SONGS[songId] || SONGS.disco;
  let mel = parse(song.melody); let bass = parse(song.bass); let drums = song.drums.replace(/ /g, '|').split('|');
  let timer = null; let step = 0; let next = 0;

  const tone = (freq, at, dur, type, vol) => {
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = type; o.frequency.value = freq;
    g.gain.setValueAtTime(0, at);
    g.gain.linearRampToValueAtTime(vol, at + 0.01);
    g.gain.exponentialRampToValueAtTime(0.001, at + dur);
    o.connect(g); g.connect(master); o.start(at); o.stop(at + dur + 0.02);
  };
  const hit = (kind, at) => {
    if (kind === 'k') {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.setValueAtTime(140, at); o.frequency.exponentialRampToValueAtTime(40, at + 0.12);
      g.gain.setValueAtTime(0.9, at); g.gain.exponentialRampToValueAtTime(0.001, at + 0.15);
      o.connect(g); g.connect(master); o.start(at); o.stop(at + 0.16);
      return;
    }
    const src = ctx.createBufferSource(); const f = ctx.createBiquadFilter(); const g = ctx.createGain();
    src.buffer = noise; f.type = 'highpass'; f.frequency.value = kind === 'h' ? 7000 : 1500;
    const len = kind === 'h' ? 0.03 : 0.12;
    g.gain.setValueAtTime(kind === 'h' ? 0.15 : 0.4, at); g.gain.exponentialRampToValueAtTime(0.001, at + len);
    src.connect(f); f.connect(g); g.connect(master); src.start(at); src.stop(at + len);
  };

  const schedule = () => {
    while (next < ctx.currentTime + 0.3) {
      const m = mel[step % mel.length]; const b = bass[step % bass.length];
      if (m !== '-') tone(hz(m), next, song.step * 0.9, song.lead, song.leadVol);
      if (b && b !== '-') tone(hz(b), next, song.step * 1.6, songId === 'piano' ? 'sine' : 'triangle', 0.5);
      if (drums.length && drums[0]) [...(drums[step % drums.length] || '')].forEach((k) => hit(k, next));
      step += 1; next += song.step;
    }
  };

  return {
    play() {
      if (ctx.state === 'suspended') ctx.resume();
      if (timer) return;
      next = ctx.currentTime + 0.05;
      timer = setInterval(schedule, 100);
    },
    pause() { clearInterval(timer); timer = null; },
    setSong(id) {
      songId = id; song = SONGS[id] || SONGS.disco;
      mel = parse(song.melody); bass = parse(song.bass); drums = song.drums.replace(/ /g, '|').split('|'); step = 0;
    },
    duck(on) { master.gain.setTargetAtTime(on ? 0.04 : 0.18, ctx.currentTime, 0.1); },
    pling() {
      if (ctx.state === 'suspended') ctx.resume();
      const t = ctx.currentTime;
      [hz('C5'), hz('E5'), hz('G5')].forEach((f, i) => tone(f, t + i * 0.12, 0.6, 'sine', 0.6));
    },
    close() { clearInterval(timer); timer = null; if (ctx.state !== 'closed') ctx.close().catch(() => {}); },
  };
}
